import apiClient from './index';
import { Token, User, UserRegister, Body_login_for_access_token_auth_token_post } from './types';

export const authApi = {
  async register(data: UserRegister): Promise<User> {
    const response = await apiClient.post<User>('/auth/register', data);
    return response.data;
  },

  async login(data: Body_login_for_access_token_auth_token_post) {
    const formData = new URLSearchParams();
    formData.append('grant_type', 'password'); // Если используется OAuth2PasswordRequestForm
    formData.append('username', data.username);
    formData.append('password', data.password || '');
    // Добавьте другие поля, если они требуются вашим FastAPI токеном
    
    // formData.append('scope', '');
    // formData.append('client_id', '');
    // formData.append('client_secret', '');


    await apiClient.post<Token>('/auth/token', formData.toString(), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        "Authorization" : "Basic " + btoa("client_id:client_secret")
      },
    });
    // return response.data;
  },

  async logout() {
    await apiClient.post('/auth/logout');
  },

  async getCurrentUser(): Promise<User> {
    const response = await apiClient.get<User>('/me');
    return response.data;
  },
}; 